// Generated by app/scripts/generate-fdic-config.ts from the /orsnn/fdic-demo/client/* SSM parameters and the alias/fdic-demo-irm-header-signing KMS public key in account 272973565736. Gitignored; do not edit -- run `make fdicConfig stage=fdic-demo` to regenerate.
const config = {
  apiGateway: {
    REGION: 'us-west-2',
    URL: 'https://76pjlm94nd.execute-api.us-west-2.amazonaws.com/prod/graphql',
  },
  logs: {
    REGION: 'us-west-2',
    URL: 'https://76pjlm94nd.execute-api.us-west-2.amazonaws.com/prod/log',
  },
  cognito: {
    REGION: 'us-west-2',
    USER_POOL_ID: 'us-west-2_r71gTNGOb',
    APP_CLIENT_ID: '21abvemeci35dfqe99je61u91g',
    IDENTITY_POOL_ID: 'us-west-2:9b45aef3-c78b-418e-9c2e-f034a47749dc',
  },
  fileGateway: {
    REGION: 'us-west-2',
    URL: 'https://76pjlm94nd.execute-api.us-west-2.amazonaws.com/prod/files',
  },
  smartHeaderGateway: {
    REGION: 'us-west-2',
    URL: 'https://76pjlm94nd.execute-api.us-west-2.amazonaws.com/prod/smart_header_mapping',
  },
  website: {
    URL: 'https://fdic-demo.orsnn.com',
  },
  pinpoint: {
    REGION: 'us-west-2',
    APP_ID: '19c58ad69aed49368dbf3820825872e8',
  },
  irm: {
    KEY_SERVICE_URL: 'https://keys.fdic-demo.orsnn.com',
    HEADER_SIGNING_KEYS: [
      {
        kid: 'baa9705700e7f3e1a7ab42810c9a232a',
        jwk: {
          kty: 'EC',
          crv: 'P-256',
          x: 'S2S6LurLnMPNR7VMPOYpk_1_PW2FFaDrh_Jnr0NwlsY',
          y: 'nCmXLWFYKp15dOewXKBx_rf1LVS7k5IB6VWAHkL6tmE',
        },
      },
    ],
  },
  features: {},
} as const;

export default config;
